import React from 'react'

import PropTypes from 'prop-types'
import { Box, Typography } from '@material-ui/core'

import useStyles from './styles'

const ResultItemList = ({ items = [] }) => {
  const classes = useStyles()

  return (
    <Box className={classes.list}>
      {items.map((item) => (
        <Box key={item?.id} className={classes.listItem}>
          <Typography variant="subtitle2" className={classes.name}>
            {item?.name}
          </Typography>
          {item?.subtitle && (
            <Typography variant="body2" color="textSecondary">
              {item.subtitle}
            </Typography>
          )}
          <Typography variant="body2">{item?.detail}</Typography>
        </Box>
      ))}
    </Box>
  )
}

ResultItemList.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      name: PropTypes.string,
      subtitle: PropTypes.string,
      detail: PropTypes.string,
    }),
  ),
}

export default ResultItemList
